<div class="content-container">
    <h1>Biler</h1>
    <router-outlet></router-outlet>
</div>
